import { useCallback } from 'react';
import {
  AuthActivateAccountPostResponseBodyBff,
  AuthActivateAccountTokenValidationGetResponseBodyBff,
} from '@goalsetter/classroom-types/auth-app';
import { apiBase, baseUrl } from './ApiBase';

const useUserSignUp = () => {
  const validateToken = useCallback(
    async (
      token: string,
    ): Promise<AuthActivateAccountTokenValidationGetResponseBodyBff> => {
      const url = `${baseUrl()}/api/auth/public/activate-account/token-validation?token=${token}`;
      return apiBase.get(url);
    },
    [],
  );

  const activateAccount = useCallback(
    async (
      token: string,
      password: string,
    ): Promise<AuthActivateAccountPostResponseBodyBff> => {
      const url = `${baseUrl()}/api/auth/public/activate-account`;
      return apiBase.post(url, { token, password }, { withCredentials: true });
    },
    [],
  );

  /** Resends the activation email. Pass full user-signup body or { token } for educator. Returns 200 when email is sent. */
  const resendActivationLink = async (
    body: { token?: string } | Record<string, unknown>,
  ): Promise<void> => {
    const url = `${baseUrl()}/api/auth/public/activate-account/resend-link`;
    await apiBase.post(url, body ?? {});
  };

  return {
    validateToken,
    activateAccount,
    resendActivationLink,
  };
};

export default useUserSignUp;
